module.exports = __webpack_public_path__ + "img/video.ebd39cd2.png";